(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@openhps/rdf"), require("@openhps/core"));
	else if(typeof define === 'function' && define.amd)
		define("OpenHPS", ["rdf", "core"], factory);
	else if(typeof exports === 'object')
		exports["OpenHPS"] = factory(require("@openhps/rdf"), require("@openhps/core"));
	else
		root["OpenHPS"] = root["OpenHPS"] || {}, root["OpenHPS"]["solid"] = factory(root["OpenHPS"]["rdf"], root["OpenHPS"]["core"]);
})((typeof self !== 'undefined' ? self : this), (__WEBPACK_EXTERNAL_MODULE__openhps_rdf__, __WEBPACK_EXTERNAL_MODULE__openhps_core__) => {
return 